interface IconProps {
  color?: string
}

export function DrivingLicense({ color }: IconProps) {
  return (
    <svg
      aria-hidden="true"
      width="26px"
      height="18px"
      viewBox="0 0 26 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.799805 3.66712C0.799805 1.71572 2.38173 0.133789 4.33314 0.133789H21.6665C23.6179 0.133789 25.1998 1.71572 25.1998 3.66712V14.3338C25.1998 16.2852 23.6179 17.8671 21.6665 17.8671H4.33314C2.38173 17.8671 0.799805 16.2852 0.799805 14.3338V3.66712ZM4.33314 1.86712C3.33903 1.86712 2.53314 2.67301 2.53314 3.66712V14.3338C2.53314 15.3279 3.33903 16.1338 4.33314 16.1338H21.6665C22.6606 16.1338 23.4665 15.3279 23.4665 14.3338V3.66712C23.4665 2.67301 22.6606 1.86712 21.6665 1.86712H4.33314Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4668 8.33346C17.4668 7.85482 17.8548 7.4668 18.3335 7.4668H21.0001C21.4788 7.4668 21.8668 7.85482 21.8668 8.33346C21.8668 8.81211 21.4788 9.20013 21.0001 9.20013H18.3335C17.8548 9.20013 17.4668 8.81211 17.4668 8.33346Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.4668 11.0005C17.4668 10.5218 17.8548 10.1338 18.3335 10.1338H21.0001C21.4788 10.1338 21.8668 10.5218 21.8668 11.0005C21.8668 11.4791 21.4788 11.8671 21.0001 11.8671H18.3335C17.8548 11.8671 17.4668 11.4791 17.4668 11.0005Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.6668 4.53411C7.19992 4.53411 5.20013 6.53391 5.20013 9.00078C5.20013 11.4677 7.19992 13.4674 9.6668 13.4674C12.1337 13.4674 14.1335 11.4677 14.1335 9.00078C14.1335 6.53391 12.1337 4.53411 9.6668 4.53411ZM3.4668 9.00078C3.4668 5.57662 6.24263 2.80078 9.6668 2.80078C13.091 2.80078 15.8668 5.57662 15.8668 9.00078C15.8668 12.4249 13.091 15.2008 9.6668 15.2008C6.24263 15.2008 3.4668 12.4249 3.4668 9.00078Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.68269 7.52328C9.30205 7.2136 10.0311 7.2136 10.6504 7.52328L12.7208 8.55847L12.3332 10.2003H6.99989L6.6123 8.55847L8.68269 7.52328Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.80049 12.075C8.80049 10.9796 7.8303 10.1382 6.74594 10.2931L5.12306 10.5249L4.87793 8.80903L6.50081 8.57719C8.62942 8.2731 10.5338 9.92485 10.5338 12.075V13.667H8.80049V12.075Z"
        fill={color ?? 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5335 12.075C10.5335 10.9796 11.5037 10.1382 12.588 10.2931L14.2109 10.5249L14.4561 8.80903L12.8332 8.57719C10.7046 8.2731 8.80016 9.92485 8.80016 12.075V13.667H10.5335V12.075Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  )
}
